import { Button } from 'react-bootstrap';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AllBlogs } from '../../Fakedata/AllBlogs';
import SingleBlog from './SingleBlog';
import './Blogs.css'

const Blogs = () => {
    const letestBlogs=AllBlogs.slice(0,3)
    return (
        <Container className='pt-5 mt-5'>
            <div className='section-header my-4'>
            <h3 >Read Me </h3>
            <Link to='/blogs'><Button className='seeFullPage buttonstyle'>All Blogs</Button></Link>
            
            </div>
            <Row>
                {
                    letestBlogs.map(bl=><SingleBlog  blog={bl}></SingleBlog>)
                }
            </Row>
                
        </Container>
    );
};

export default Blogs;